import type { Page, UUID } from '@protector/utils/types';
import type { MethodologyEntity } from '../../methodology/models.ts';
import type { IndicatorDTO, Phenomenon } from '../../phenomenon/models.ts';
import type {
  CurrentSeasonArea,
  GetCurrentSeasonAreaPayload,
  GetCurrentSeasonAreasSuccessType,
  IndicatorPressureResponse,
  LoadPropertiesParams,
  Property,
  PropertyInfoAddress,
  PropertyPage
} from '../models.ts';
import { PropertyActionsTypes } from './redux.constants.ts';

export const LoadPropertiesAreaInfo = (pageableQuery: Page<LoadPropertiesParams>) => {
  return {
    type: PropertyActionsTypes.LOAD_PROPERTIES_AREA_INFO,
    payload: pageableQuery
  };
};

export const LoadProperties = (pageableQuery: Page<LoadPropertiesParams>) => {
  return {
    type: PropertyActionsTypes.LOAD_PROPERTIES,
    payload: pageableQuery
  };
};

export const LoadPropertiesSuccess = (propertyPage: PropertyPage) => {
  return {
    type: PropertyActionsTypes.LOAD_PROPERTIES_SUCCESS,
    payload: propertyPage
  };
};

export const LoadPropertiesFailure = (error: string) => {
  return {
    type: PropertyActionsTypes.LOAD_PROPERTIES_FAILURE,
    payload: error
  };
};

export const LoadPropertiesAreaInfoSuccess = (propertyPage: Page<Property>) => {
  return {
    type: PropertyActionsTypes.LOAD_PROPERTIES_AREA_INFO_SUCCESS,
    payload: propertyPage
  };
};

export const LoadPropertyDataSuccess = (propertyData: PropertyInfoAddress) => {
  return {
    type: PropertyActionsTypes.LOAD_PROPERTY_DATA_SUCCESS,
    payload: propertyData
  };
};

export const LoadPropertyDataFailure = (error: string) => {
  return {
    type: PropertyActionsTypes.LOAD_PROPERTY_DATA_FAILURE,
    payload: error
  };
};

export const LoadPropertyPhenomena = (propertyId: UUID, seasonIds: UUID[], areaIds: UUID[]) => ({
  type: PropertyActionsTypes.LOAD_PROPERTY_PHENOMENA,
  payload: { propertyId, seasonIds, areaIds }
});

export const LoadPropertyPhenomenaSuccess = (phenomenons: Phenomenon[]) => ({
  type: PropertyActionsTypes.LOAD_PROPERTY_PHENOMENA_SUCCESS,
  payload: phenomenons
});

export const LoadPropertyIndicatorsSuccess = (indicators: IndicatorDTO[]) => ({
  type: PropertyActionsTypes.LOAD_PROPERTY_INDICATORS_SUCCESS,
  payload: indicators
});

export const LoadPropertyMethodologiesSuccess = (methodologies: MethodologyEntity[]) => ({
  type: PropertyActionsTypes.LOAD_PROPERTY_METHODOLOGIES_SUCCESS,
  payload: methodologies
});

export const LoadPropertyTime = (id: UUID) => {
  return {
    type: PropertyActionsTypes.LOAD_PROPERTY_TIME,
    payload: id
  };
};

export const LoadPropertyTimeSuccess = (time: string) => {
  return {
    type: PropertyActionsTypes.LOAD_PROPERTY_TIME_SUCCESS,
    payload: time
  };
};

export const GetCurrentSeasonAreas = (propertyId: GetCurrentSeasonAreaPayload) => {
  return {
    type: PropertyActionsTypes.GET_CURRENT_SEASON_AREAS,
    payload: propertyId
  };
};

export const GetCurrentSeasonAreasSuccess = (content: GetCurrentSeasonAreasSuccessType) => {
  return {
    type: PropertyActionsTypes.GET_CURRENT_SEASON_AREAS_SUCCESS,
    payload: content
  };
};

export const GetCurrentSeasonAreasFailure = (error: string, requestId?: string) => {
  return {
    type: PropertyActionsTypes.GET_CURRENT_SEASON_AREAS_FAILURE,
    payload: error,
    requestId
  };
};

export const LoadSeverityByIndicator = (propertyId: UUID, indicatorIds: UUID[], methodologyIds: UUID[]) => ({
  type: PropertyActionsTypes.LOAD_SEVERITY_BY_INDICATOR,
  payload: { propertyId, indicatorIds, methodologyIds }
});

export const LoadSeverityByIndicatorSuccess = (data: IndicatorPressureResponse[], indicator: UUID) => ({
  type: PropertyActionsTypes.LOAD_SEVERITY_BY_INDICATOR_SUCCESS,
  payload: { data, indicator }
});

export const ClearIndicatorPressure = () => ({
  type: PropertyActionsTypes.CLEAR_INDICATOR_SEVERITY
});

export const SetUseNewMapColors = (value: boolean) => ({
  type: PropertyActionsTypes.SET_USE_NEW_MAP_COLORS_FLAG,
  payload: value
});

export const GetSeasonAreasByDate = (payload: GetCurrentSeasonAreaPayload) => {
  return {
    type: PropertyActionsTypes.GET_SEASON_AREAS_BY_DATE,
    payload
  };
};

export const GetSeasonAreasByDateSuccess = (content: { date: string | undefined; content: CurrentSeasonArea[] }) => {
  return {
    type: PropertyActionsTypes.GET_SEASON_AREAS_BY_DATE_SUCCESS,
    payload: content
  };
};

export const GetSeasonAreasByDateFailure = (error: string) => {
  return {
    type: PropertyActionsTypes.GET_SEASON_AREAS_BY_DATE_FAILURE,
    payload: error
  };
};

export const SetPropertyBasicDataIsLoaded = (value: boolean) => {
  return {
    type: PropertyActionsTypes.SET_PROPERTY_BASIC_DATA_IS_LOADED,
    payload: value
  };
};
